import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { get, postAndForget, getAndForget } from "../lib/comm";
import {
  GROUP_VARIABLE,
  MainContext,
  STATUS_ONLINE,
  UIContext,
  UpdateContext,
} from "../main-context";
import Spinner from "./helpers/Spinner";
export const OPERATION_FUEL_FARM = 2;

export default function Filter({ filterOpen, setFilterOpen }) {
  // var TIME_TO_INTERACT_WITH_PAGE = 4000;
  // $timeout(function () {
  //   /* If we invoke this immediately, when user has "All Stations"
  //    * selected, "All Stations" will be incorrectly reset to first station
  //    * when page loads. How to tell if this is a user initiated event? Add
  //    * a timer which gives the user a few seconds before interacting. */
  //   $scope.$watch("selected.vendor", function (newValue, oldValue) {
  //     if (newValue && newValue != oldValue) {
  //       /* When vendor changes from user selection, select the first
  //        * station within the available list of stations.  We could choose
  //        * "All Stations", however, some groups do not have "All Stations".
  //        * Therefore to make it work same across all users, * choose first
  //        * station. Nice to avoid special exceptions. */
  //       $scope.selected.station = $scope.selected.vendor.stations[0];
  //     }
  //   });
  // }, TIME_TO_INTERACT_WITH_PAGE);

  const update_context = useContext(UpdateContext);
  const main_context = useContext(MainContext);
  const ui_context = useContext(UIContext);
  const history = useHistory();
  const [selectedIds, set_selectedIds] = useState({});
  const [selectedVendor, set_selectedVendor] = useState({});
  const [selectedStation, set_selectedStation] = useState({});
  const [selectedOperation, set_selectedOperation] = useState({});
  const [availableOps, set_availableOps] = useState("");
  const [progress, set_progress] = useState(false);
  const buttonRef = useRef();
  const applyDefaults = useCallback((vendors, vendorId, stationId) => {
    vendors.forEach(function (vendor) {
      if (vendor.id === vendorId) {
        set_selectedVendor(vendor);
        vendor.stations.forEach(function (station) {
          if (station.id === stationId) {
            set_selectedStation(station);
          }
        });
      }
    });
  }, []);

  const applyOperationsDefaults = useCallback((operations, operationId) => {
    if (operationId.length > 1) {
      set_selectedOperation("");
    } else {
      operations.forEach(function (operation) {
        if (+operation.id === +operationId) {
          set_selectedOperation(operation);
        }
      });
    }
  }, []);

  const setFuelFarm = useCallback(
    (preferences) => {
      console.log("TEST");
      const isfuelfarm = preferences.operationId
        .map((x) => +x)
        .includes(OPERATION_FUEL_FARM);
      const group = main_context?.status?.group?.id;
      if (!group) return;

      const variable = GROUP_VARIABLE[group];

      if (!variable) throw "Please setup variable fro group: ".group;

      update_context.update_main_context((prev) => ({
        ...prev,
        [variable]: {
          ...prev[variable],
          isfuelfarm,
        },
      }));
    },
    [main_context?.status?.group?.id, update_context]
  );

  useEffect(() => {
    async function call_api() {
      const vendors = await get(
        "/api/vendors",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (vendors === "comm error") return;

      const operations = await get(
        "/api/offline/operations",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (operations === "comm error") return;

      const preferences = await get(
        "/api/offline/preferences",
        null,
        main_context.status.id,
        update_context,
        history
      );

      if (preferences === "comm error") return;

      update_context.update_main_context((prev) => ({
        ...prev,
        vendors: vendors,
        operations: operations,
        status: {
          ...prev.status,
          station_id: preferences.station_id,
          vendor_id: preferences.vendor_id,
          station: preferences.station,
          vendor: preferences.vendor,
          preferences: preferences.preferences,
          can_change_prefs: preferences.can_change_prefs,
          date_string: preferences.date_string,
        },
      }));

      set_selectedIds({
        operationId: preferences.preferences.operationId,
        vendorId: preferences.vendor_id,
        stationId: preferences.station_id,
      });

      setFuelFarm(preferences.preferences);

      applyDefaults(vendors, preferences.vendor_id);
      const arrAkronims = {
        1: "ITP",
        2: "FF",
        3: "GSE",
      };
      const arrA = [];
      for (let i = 0; i < operations.length; i++) {
        arrA.push(arrAkronims[operations[i].id]);
      }
      set_availableOps(arrA.join(","));
      applyOperationsDefaults(operations, preferences.preferences.operationId);
    }
    call_api();
  }, [
    applyDefaults,
    applyOperationsDefaults,
    history,
    main_context.status.id,
    setFuelFarm,
    update_context,
  ]);

  const applyFilter = useCallback(
    async (event) => {
      event.preventDefault();
      const data = {
        vendor_id: selectedVendor && selectedVendor.id,
        station_id: selectedStation && selectedStation.id,
        operation_id: selectedOperation && selectedOperation.id,
      };

      set_progress(true);
      let full_res = "comm error";
      if (ui_context.online_status === STATUS_ONLINE) {
        await postAndForget("/home/set-preferences", data, update_context);

        full_res = await getAndForget(
          "/api/offline/preferences",
          {},
          update_context
        );
      }

      if (full_res !== "comm error") {
        const res = full_res[0];
        update_context.update_main_context((prev) => ({
          ...prev,

          status: {
            ...prev.status,
            station_id: res.station_id,
            vendor_id: res.vendor_id,
            station: res.station,
            vendor: res.vendor,
            preferences: res.preferences,
            can_change_prefs: res.can_change_prefs,
            date_string: res.date_string,
          },
        }));
        set_selectedIds({
          operationId: res.preferences.operationId,
          vendorId: res.vendor_id,
          stationId: res.station_id,
        });

        setFuelFarm(res.preferences);
      } else {
        const operationId = [];
        if (selectedOperation === "") {
          main_context.operations.forEach((x) => operationId.push(x.id));
        } else if (selectedOperation && selectedOperation.id) {
          operationId.push(selectedOperation.id);
        }
        const ids = {
          operationId: operationId,
          vendorId:
            main_context.vendors.length > 1
              ? selectedVendor && selectedVendor.id
              : selectedIds.vendorId,
          stationId:
            main_context.vendors.length > 1
              ? selectedStation && selectedStation.id
              : selectedIds.stationId,
        };
        set_selectedIds(ids);
        update_context.update_main_context((prev) => ({
          ...prev,
          status: {
            ...prev.status,
            preferences: ids,
          },
        }));

        setFuelFarm(ids);
      }

      setFilterOpen(false);
      history.push("/");
      history.goBack();
      set_progress(false);
      console.log("TEST");
    },
    [
      history,
      main_context.operations,
      main_context.vendors.length,
      selectedIds.stationId,
      selectedIds.vendorId,
      selectedOperation,
      selectedStation,
      selectedVendor,
      setFilterOpen,
      setFuelFarm,
      ui_context.online_status,
      update_context,
    ]
  );

  return (
    <MainContext.Consumer>
      {({ status, constants, vendors, operations }) => (
        <>
          {vendors && !!vendors.length && (
            <form
              className="form-inline filter-form"
              style={{ float: "right", margin: 0, padding: 0 }}
            >
              <div
                className={`expanded-filter ffcol ${
                  filterOpen ? "force-display" : ""
                }`}
              >
                {operations && operations.length > 1 && (
                  <div className="form-group">
                    <select
                      value={
                        selectedOperation !== ""
                          ? !selectedOperation.id
                            ? ""
                            : +selectedOperation.id
                          : ""
                      }
                      onChange={(elem) =>
                        set_selectedOperation(
                          elem.target.value
                            ? operations.find(
                                (x) => x.id === +elem.target.value
                              )
                            : ""
                        )
                      }
                      className="form-control"
                      style={{ maxWidth: "110px" }}
                    >
                      <option value="">
                        {status.group.name === constants.SUPER_ADMINS
                          ? "All Ops"
                          : "All Ops (" + availableOps + ")"}
                      </option>
                      {operations.map((elem) => (
                        <option value={elem.id} key={elem.id}>
                          {elem.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {vendors && vendors.length > 1 && (
                  <div className="form-group">
                    <select
                      onChange={(elem) => {
                        set_selectedOperation(
                          elem.target.value
                            ? vendors.find((x) => x.id === +elem.target.value)
                            : ""
                        );
                        // set_selectedStation(null);
                      }}
                      className="form-control"
                      style={{ maxWidth: "110px" }}
                    >
                      {status.group.name !== constants.AIRLINES && (
                        <option value="">All Vendors/Stations</option>
                      )}
                      {vendors.map((elem) => (
                        <option value={elem.id} key={elem.id}>
                          {elem.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {status.group.name !== constants.ADMINS &&
                  status.group.name !== constants.MAINTAINERS &&
                  status.group.name !== constants.FUELERS && (
                    <>
                      {selectedVendor && vendors.length >= 1 && (
                        <div className="form-group">
                          <select
                            onChange={(elem) => {
                              set_selectedStation(
                                elem.target.value
                                  ? selectedVendor.stations.find(
                                      (x) => x.id === +elem.target.value
                                    )
                                  : ""
                              );
                              // set_selectedStation(null);
                            }}
                            className="form-control"
                            style={{ maxWidth: "110px" }}
                          >
                            {status.group.name !== constants.VENDOR_ADMINS &&
                              status.group.name !== constants.AIRLINES && (
                                <option value="">All Stations</option>
                              )}
                            {selectedVendor.stations &&
                              selectedVendor.stations.map((elem) => (
                                <option value={elem.id} key={elem.id}>
                                  {"+" + elem.iata + "+" + elem.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      )}
                    </>
                  )}
                {(operations.length > 1 || vendors.length > 1) && (
                  <>
                    {" "}
                    <div className="form-group">
                      <button
                        ref={(ref) => (buttonRef.current = ref)}
                        onClick={(event) => applyFilter(event)}
                        className="btn btn-default"
                        style={{ position: "relative" }}
                      >
                        <Spinner
                          spin={progress}
                          spinhideInnerHtml={true}
                          parentRef={buttonRef}
                        >
                          Filter
                        </Spinner>
                      </button>
                    </div>
                  </>
                )}
              </div>
            </form>
          )}
        </>
      )}
    </MainContext.Consumer>
  );
}
